<template>
  <div class="features mt-4 mb-3">
    <div>
      <i class="budicon-location-pin"></i>
      <span class="ml-2">{{ rentalObjectAddress.street ? rentalObjectAddress.street : 'n/a' }}</span
      >,
      <span class="ml-2 text-secondary text-small">{{ rentalObjectAddress.postalZipcode }}</span>
      <span class="ml-2 text-secondary text-small">{{ rentalObjectAddress.postalArea }}</span>
    </div>

    <div class="details">
      <hl-Tooltip>
        <template v-slot:inner>
          <i :class="objectTypeIconClass"></i>
          <span class="ml-2">{{ objectType ? objectType : 'n/a' }}</span>
        </template>
        <template v-slot:tooltipText>Boligtype</template>
      </hl-Tooltip>

      <hl-Tooltip>
        <template v-slot:inner>
          <i class="budicon-door"></i>
          <span class="ml-2">
            {{ rentalObjectDetails.apartmentNumber ? rentalObjectDetails.apartmentNumber : 'n/a' }}
          </span>
        </template>
        <template v-slot:tooltipText>Leilighetsnummer</template>
      </hl-Tooltip>

      <hl-Tooltip>
        <template v-slot:inner>
          <i class="budicon-monitor-resolution"></i>
          <span class="ml-2">{{ rentalObjectDetails.roomNumber ? rentalObjectDetails.roomNumber : 'n/a' }}</span>
        </template>
        <template v-slot:tooltipText>Romnummer</template>
      </hl-Tooltip>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Tooltip from '@modules/husleie-framework/src/components/tooltips/Tooltip.vue';

export default {
  components: {
    'hl-Tooltip': Tooltip,
  },
  props: {
    rentalObjectId: Number,
  },

  computed: {
    rentalObjectAddress() {
      return this.$store.getters.getRentalObject(this.rentalObjectId).address;
    },

    rentalObjectDetails() {
      return this.$store.getters.getRentalObject(this.rentalObjectId).details;
    },

    objectType() {
      if (this.rentalObjectDetails.type === 'house') {
        return 'Enebolig';
      }

      if (this.rentalObjectDetails.type === 'apartment') {
        return 'Leilighet';
      }

      if (this.rentalObjectDetails.type === 'co-op') {
        return 'Rom i bofellesskap';
      }

      if (this.rentalObjectDetails.type === 'semi-detached') {
        return 'Tomannsbolig';
      }

      if (this.rentalObjectDetails.type === 'chained-house') {
        return 'Rekkehus';
      }

      if (this.rentalObjectDetails.type === 'commercial') {
        return 'Næringseiendom';
      }

      if (this.rentalObjectDetails.type === 'garage-parking') {
        return 'Garasje / parkering';
      }

      if (this.rentalObjectDetails.type === 'dorm') {
        return 'Hybel';
      }

      return 'Ukjent (' + this.rentalObjectDetails.type + ')';
    },

    objectTypeIconClass() {
      if (this.objectType === 'house') {
        return 'Rekkehus';
      } else return 'budicon-apartment-a';
    },
  },
};
</script>

<style lang="scss" scoped>
.features {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 24px;

  @media screen and (min-width: 950px) {
    flex-direction: row;
  }
}

.details {
  display: flex;
  gap: 16px;
}
</style>
